import React, {Component} from 'react';
import StyledSelect from 'components/StyledSelect';

class RespForm extends Component {
    render() {
        const {lowError, handleRangeChange, lowErrorOptions, lowWarnOptions, lowErrorvery_low_warn_alert_time, handleResetDefaultRespiration, highErrorvery_high_urgent_alert_time, highErrorvery_high_warn_alert_time, rrWarningTimerOptions, normal, handleChange, nomalRange, lowErrorvery_low_urgent_alert_time, lowWarn} = this.props;
        return(
            <div className='rr-settings'>
                <div className='card'>
                    <div className='card-header'>
                        Respiration Range
                    </div>
                    <section className='instructions'>
                        Set the ranges for Respiration. Please note that you may need to go back and adjust other levels if you make a change.
                    </section>
                    <div className='card-body'>
                        <div className="rr-setting-box">
                            <div className="row">
                                <div className="col-md-5 col-xs-12 rr-box">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <label className="d-flex align-items-center justify-content-center">
                                                <div>
                                                    Low
                                                </div>
                                            </label>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <strong>0</strong>&nbsp; RR &mdash;
                                                <StyledSelect
                                                    className='form-control'
                                                    name='setting.rr.very_low'
                                                    value={lowError}
                                                    onChange={handleRangeChange} >
                                                    {lowErrorOptions.map((i) => <option key={i} value={i} disabled={i > (normal-1)}>{i}&nbsp; RR</option>)}
                                                </StyledSelect>
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <label className="d-flex align-items-center justify-content-center">
                                                <div>
                                                    Alerts
                                                </div>
                                            </label>
                                            <div className="row">
                                                <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                    <div className="form-group">
                                                        Warning
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <StyledSelect
                                                            className='form-control'
                                                            name='setting.rr.very_low_warn_alert_time'
                                                            value={lowErrorvery_low_warn_alert_time}
                                                            onChange={handleChange} >
                                                            {rrWarningTimerOptions.map((time) => (
                                                                <option key={time} value={time}>{time} Minutes</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                    <div className="form-group">
                                                        Urgent
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <StyledSelect
                                                            className='form-control'
                                                            name='setting.rr.very_low_urgent_alert_time'
                                                            value={lowErrorvery_low_urgent_alert_time}
                                                            onChange={handleChange} >
                                                            <option value={60}>1 Hour</option>
                                                            <option value={120}>2 Hours</option>
                                                            <option value={180}>3 Hours</option>
                                                            <option value={240}>4 Hours</option>
                                                            <option value={300}>5 Hours</option>
                                                            <option value={360}>6 Hours</option>
                                                        </StyledSelect>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2 col-xs-12 rr-box brl">
                                    <label className="d-flex align-items-center justify-content-center">
                                        <div>
                                            Normal
                                        </div>
                                    </label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <strong>{lowWarn ? lowWarn + 1 : lowError + 1}</strong>&nbsp; RR &mdash;
                                        <StyledSelect
                                            className='form-control'
                                            name='setting.rr.normal'
                                            value={normal}
                                            onChange={handleRangeChange} >
                                            {lowWarnOptions.map((i) => (
                                                <option key={i} value={i} disabled={i < nomalRange }>{i}&nbsp; RR</option>
                                            ))}
                                        </StyledSelect>
                                    </div>
                                </div>
                                <div className="col-md-5 col-xs-12 rr-box">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <label className="d-flex align-items-center justify-content-center">
                                                <div>
                                                    High
                                                </div>
                                            </label>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <strong>{parseInt(normal, 10) + 1}</strong>&nbsp; RR &nbsp;
                                                <strong>and over</strong>
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <label className="d-flex align-items-center justify-content-center">
                                                <div>
                                                    Alerts
                                                </div>
                                            </label>
                                            <div className="row">
                                                <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                    <div className="form-group">
                                                        Warning
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <StyledSelect
                                                            className='form-control'
                                                            name='setting.rr.very_high_warn_alert_time'
                                                            value={highErrorvery_high_warn_alert_time}
                                                            onChange={handleChange} >
                                                            {rrWarningTimerOptions.map((time) => (
                                                                <option key={time} value={time}>{time} Minutes</option>
                                                            ))}
                                                        </StyledSelect>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                    <div className="form-group">
                                                        Urgent
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <StyledSelect
                                                            className='form-control'
                                                            name='setting.rr.very_high_urgent_alert_time'
                                                            value={highErrorvery_high_urgent_alert_time}
                                                            onChange={handleChange} >
                                                            <option value={60}>1 Hour</option>
                                                            <option value={120}>2 Hours</option>
                                                            <option value={180}>3 Hours</option>
                                                            <option value={240}>4 Hours</option>
                                                            <option value={300}>5 Hours</option>
                                                            <option value={360}>6 Hours</option>
                                                        </StyledSelect>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card-footer text-right'>
                        <button className='btn btn-secondary' onClick={handleResetDefaultRespiration}>Return to Default</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default RespForm;
